import { Link } from 'react-router-dom';

const ProgramasIncentivosPage = () => {
  const programs = [
    {
      id: 1,
      title: 'Programa de Reconhecimento',
      description: 'Valorizamos e reconhecemos o desempenho excepcional de nossos colaboradores através de premiações e benefícios especiais.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20employee%20recognition%20award%20ceremony%20in%20modern%20corporate%20office%2C%20team%20celebrating%20achievement%20with%20trophy%20and%20certificates%2C%20diverse%20business%20professionals%20smiling%20and%20applauding%2C%20bright%20contemporary%20workspace%20with%20teal%20and%20orange%20corporate%20branding%2C%20motivational%20workplace%20culture%2C%20professional%20business%20photography&width=800&height=600&seq=prog-1&orientation=landscape',
      icon: 'ri-trophy-line'
    },
    {
      id: 2,
      title: 'Desenvolvimento Profissional',
      description: 'Investimos no crescimento contínuo de nossa equipe com treinamentos, cursos e programas de capacitação profissional.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20training%20session%20in%20modern%20conference%20room%2C%20professional%20instructor%20teaching%20business%20skills%20to%20engaged%20employees%2C%20interactive%20workshop%20with%20presentation%20screens%2C%20contemporary%20learning%20environment%2C%20diverse%20team%20members%20taking%20notes%2C%20professional%20development%20atmosphere%20with%20teal%20and%20orange%20accents&width=800&height=600&seq=prog-2&orientation=landscape',
      icon: 'ri-graduation-cap-line'
    },
    {
      id: 3,
      title: 'Qualidade de Vida',
      description: 'Programas focados no bem-estar físico e mental dos colaboradores, incluindo atividades esportivas, ginástica laboral e apoio psicológico.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20wellness%20program%20with%20employees%20doing%20yoga%20and%20stretching%20exercises%20in%20modern%20office%20gym%2C%20healthy%20lifestyle%20activities%2C%20group%20fitness%20class%20in%20bright%20spacious%20room%2C%20professional%20wellness%20instructor%2C%20diverse%20team%20members%20in%20sportswear%2C%20positive%20energetic%20atmosphere%20with%20natural%20lighting&width=800&height=600&seq=prog-3&orientation=landscape',
      icon: 'ri-heart-pulse-line'
    },
    {
      id: 4,
      title: 'Benefícios Corporativos',
      description: 'Pacote completo de benefícios que inclui plano de saúde, vale-alimentação, vale-transporte e parcerias com estabelecimentos.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20benefits%20concept%20with%20healthcare%20cards%2C%20meal%20vouchers%2C%20transportation%20passes%20and%20discount%20partnership%20cards%20arranged%20professionally%2C%20modern%20business%20still%20life%20photography%2C%20clean%20organized%20display%20of%20employee%20benefits%2C%20teal%20and%20orange%20branded%20materials%2C%20professional%20corporate%20imagery&width=800&height=600&seq=prog-4&orientation=landscape',
      icon: 'ri-gift-line'
    },
    {
      id: 5,
      title: 'Programa de Metas',
      description: 'Sistema de bonificação por atingimento de metas individuais e coletivas, incentivando a excelência e o trabalho em equipe.',
      image: 'https://readdy.ai/api/search-image?query=Business%20team%20celebrating%20achievement%20of%20goals%20and%20targets%2C%20professionals%20high-fiving%20in%20modern%20office%2C%20success%20celebration%20with%20charts%20showing%20growth%2C%20motivated%20employees%20around%20conference%20table%2C%20contemporary%20corporate%20environment%20with%20digital%20displays%2C%20teamwork%20and%20achievement%20atmosphere&width=800&height=600&seq=prog-5&orientation=landscape',
      icon: 'ri-line-chart-line'
    },
    {
      id: 6,
      title: 'Integração e Eventos',
      description: 'Eventos corporativos, confraternizações e atividades de integração que fortalecem o espírito de equipe e a cultura organizacional.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20building%20event%20with%20employees%20participating%20in%20fun%20group%20activities%2C%20outdoor%20company%20picnic%20with%20games%20and%20food%2C%20diverse%20team%20members%20laughing%20and%20bonding%2C%20casual%20professional%20atmosphere%2C%20modern%20corporate%20culture%20celebration%20with%20teal%20and%20orange%20decorations&width=800&height=600&seq=prog-6&orientation=landscape',
      icon: 'ri-team-line'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-teal-50">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-r from-teal-600 to-orange-500 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="text-center text-white">
            <div className="inline-flex items-center gap-2 px-5 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-6">
              <i className="ri-award-line text-xl"></i>
              <span className="text-sm font-semibold">Pessoas & Cultura</span>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold mb-6">
              Programas de Incentivos
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto leading-relaxed">
              Valorizamos nossos colaboradores através de programas que promovem desenvolvimento, reconhecimento e qualidade de vida
            </p>
          </div>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-teal-600 transition-colors cursor-pointer">
              Início
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-medium">Programas de Incentivos</span>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              Investindo em Nosso Maior Ativo: Pessoas
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Na Sustentare, acreditamos que colaboradores motivados e valorizados são essenciais para o sucesso da empresa. Por isso, desenvolvemos diversos programas de incentivos que promovem o crescimento profissional, reconhecem conquistas e garantem qualidade de vida para toda nossa equipe.
            </p>
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-user-heart-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Valorização</h3>
                <p className="text-gray-600">Reconhecemos e premiamos o esforço de cada colaborador</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-rocket-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Crescimento</h3>
                <p className="text-gray-600">Investimos no desenvolvimento contínuo da equipe</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-heart-3-line text-3xl text-teal-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Bem-estar</h3>
                <p className="text-gray-600">Cuidamos da saúde física e mental de todos</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Grid */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Nossos Programas
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Conheça as iniciativas que fazem da Sustentare um excelente lugar para trabalhar
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {programs.map((program) => (
              <div
                key={program.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
              >
                <div className="relative w-full h-64 overflow-hidden">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-lg">
                      <i className={`${program.icon} text-2xl text-teal-600`}></i>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {program.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="bg-gradient-to-r from-teal-600 to-orange-500 rounded-3xl p-12 text-white">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Resultados que Transformam
              </h2>
              <p className="text-xl text-white/95 mb-12 leading-relaxed">
                Nossos programas de incentivos geram impacto positivo em toda a organização
              </p>
              <div className="grid md:grid-cols-4 gap-8">
                <div className="text-center">
                  <div className="text-5xl font-bold mb-2">95%</div>
                  <p className="text-white/90">Satisfação dos Colaboradores</p>
                </div>
                <div className="text-center">
                  <div className="text-5xl font-bold mb-2">87%</div>
                  <p className="text-white/90">Taxa de Retenção</p>
                </div>
                <div className="text-center">
                  <div className="text-5xl font-bold mb-2">120+</div>
                  <p className="text-white/90">Horas de Treinamento/Ano</p>
                </div>
                <div className="text-center">
                  <div className="text-5xl font-bold mb-2">100%</div>
                  <p className="text-white/90">Cobertura de Benefícios</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-briefcase-line text-4xl text-teal-600"></i>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            Faça Parte do Nosso Time
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Venha trabalhar em uma empresa que valoriza pessoas, investe em desenvolvimento e oferece excelentes oportunidades de crescimento
          </p>
          <Link
            to="/contato"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-teal-600 to-orange-500 text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span>Entre em Contato</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProgramasIncentivosPage;
